export function _generateUUID() {
    let dt = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        // tslint:disable-next-line:no-bitwise
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
export function mainThread(thread) {
    return thread || "4dd12fb4-908b-44f5-bb56-7ddbf54c5302";
}
export function isMamMessage(msg) {
    return msg.stanza && msg.stanza.rawStanza && msg.stanza.rawStanza.indexOf(' queryid="') !== -1;
}
export function isIncomingMessage(msg) {
    return msg.stanza && msg.stanza.direction === "in";
}
export function debounce(handlerFunc, delay = 1000) {
    let timerId = null;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => handlerFunc(...args), delay);
    };
}
export function getNiceUrlQueryParams(urlArr = []) {
    let queryParams = {};
    urlArr.forEach(query => {
        const itemArr = query.split("=");
        if (itemArr.length >= 2) {
            queryParams[itemArr[0]] = itemArr[1];
        }
    });
    return queryParams;
}
export function getUrlQueryParams() {
    const location = window.location.toString();
    const queryUrl = location.split("?");
    const rawURL = queryUrl.length >= 2 ? queryUrl[1].replace(/&amp;/g, "&") : "";
    const urlArr = rawURL ? decodeURIComponent(rawURL).split("&") : [];
    return getNiceUrlQueryParams(urlArr);
}
